import React, { useEffect, useRef, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { getObjectiveLocale } from 'utils/HelperUtils';
import TooltipPortal from 'components/shared/Tooltips/TooltipPortal';
const TooltipContainer = ({ tooltipClass = '', backgroundClassname = 'bg-n-900', show, text, children, classContainer = '', position = 'top', align = 'middle', onClick, dataCy, customStyle, wrap = false, dataCyTooltip, useMaxWidth = true, textChangeable = false, callbackRef, tooltipContent, useMousePosition, isPassPropsToChildren, disableStack // use this props if you don't want the current tooltip to appear with another tooltip so it would be hidden and keep another tooltip appear
 }) => {
    const [portalData, setPortalData] = useState({});
    const [clientRect, setClientRect] = useState();
    const [isTooltipShown, setIsTooltipShown] = useState(false);
    const showRef = useRef(show);
    const timeoutId = useRef(null);
    const tooltipId = uuidv4();
    const localizedText = getObjectiveLocale(text);
    const setPortal = ({ top, left }) => {
        if (!showRef.current)
            return;
        const rect = clientRect && clientRect?.getBoundingClientRect();
        setIsTooltipShown(true);
        const portalData = {
            name: localizedText,
            noWrap: !wrap
        };
        tooltipContent && (portalData.tooltipContent = tooltipContent());
        if (rect) {
            switch (align) {
                case 'left':
                    portalData.left = rect?.left;
                    break;
                case 'middle':
                    portalData.left = rect?.left + rect?.width / 2;
                    portalData.translateX = '-50%';
                    break;
                case 'right':
                    portalData.left = rect?.right;
                    portalData.translateX = '-100%';
                    break;
            }
            switch (position) {
                case 'top':
                    portalData.top = rect?.top - 8;
                    portalData.translateY = '-100%';
                    break;
                case 'bottom':
                    portalData.top = rect?.bottom + 8;
                    break;
            }
        }
        if (useMousePosition) {
            portalData.left = left;
            portalData.top = top;
        }
        setPortalData(portalData);
    };
    const handleRef = (ref) => {
        setClientRect(ref);
        callbackRef && callbackRef(ref);
    };
    const onMouseEnter = (e) => {
        const clientX = e.clientX;
        const clientY = e.clientY;
        timeoutId.current = setTimeout(() => {
            setPortal({ top: clientY, left: clientX });
        }, 500);
    };
    const onMouseLeave = () => {
        setIsTooltipShown(false);
        timeoutId?.current && clearTimeout(timeoutId.current);
    };
    useEffect(() => {
        if (textChangeable && isTooltipShown) {
            setPortalData((data) => {
                return {
                    ...data,
                    name: text
                };
            });
        }
    }, [text, setPortalData, isTooltipShown, textChangeable]);
    useEffect(() => {
        !show && onMouseLeave();
    }, [show]);
    useEffect(() => {
        showRef.current = show;
    }, [show]);
    useEffect(() => {
        if (!disableStack)
            return;
        const sharedTooltip = document.getElementById(`shared-tooltip`);
        if (!sharedTooltip)
            return;
        const observer = new MutationObserver((mutationList) => {
            mutationList.forEach(function (mutation) {
                const currentTooltip = document.getElementById(tooltipId);
                if (mutation.type != 'childList')
                    return;
                if (sharedTooltip.children.length > 1) {
                    currentTooltip?.classList.add('hidden');
                    return;
                }
                currentTooltip?.classList.remove('hidden');
            });
        });
        observer.observe(sharedTooltip, { childList: true, subtree: true });
        return () => observer.disconnect();
    }, [tooltipId, disableStack]);
    const propsElement = {
        className: classContainer,
        ref: (ref) => ref && handleRef(ref),
        onMouseEnter: (e) => onMouseEnter(e),
        onMouseLeave,
        onPointerLeave: onMouseLeave,
        'data-cy': dataCy,
        onClick,
        style: customStyle
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(TooltipPortal, { show: isTooltipShown, portalData: portalData, portalId: "shared-tooltip", className: `${tooltipClass} ${useMaxWidth ? 'max-w-[240px]' : ''}`, dataCy: dataCyTooltip, tooltipId: tooltipId, backgroundClassname: backgroundClassname }),
        isPassPropsToChildren && React.isValidElement(children) ? (React.cloneElement(children, { ...propsElement })) : (React.createElement("div", { ...propsElement }, children))));
};
export default TooltipContainer;
